import { render, staticRenderFns } from "./FunnelList.vue?vue&type=template&id=4712c15c&scoped=true&"
import script from "./FunnelList.vue?vue&type=script&lang=js&"
export * from "./FunnelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712c15c",
  null
  
)

export default component.exports